import { fork, put, select, takeLatest } from 'redux-saga/effects';

import { putAndWaitHandleAllAPIError } from '../../api/API.sagas';
import {
    API_GET_CUSTOMER_STATE,
    API_GET_APPLICATION,
    API_GET_ACCOUNTS
} from '../../api/lendingAPI/LendingAPI.actions';
import { createWorkersForPage } from '../pageStructure/routerWorkers/PageWorkerFactory.sagas';
import { ACTIVATE_FLEXI12_DASHBOARD } from './Dashboard.actions';
import { isIwocaPayCustomer as isIwocaPayCustomerSelector } from '../../api/iwocaPaySelector';
import { activateMultiLoanDashboard } from '../multiLoanDashboard/Dashboard.sagas';
import {
    hasOtherValidAccounts,
    IWOCAPAY_PRODUCT_TYPE
} from '../multiLoanDashboard/accountsSelector';
import { REQUEST_CHANGE_ROUTER } from '../../iwRouter/IwRouter.actions';
import { hasOtherValidApplications } from '../../api/lendingAPI/ApplicationSelector';
import { getDefaultDashboardLocation } from './getDefaultDashboardLocation';
import { MY_OFFERS_URL } from '../myOffers/MyOffers.sagas';

export const FLEXI_12_URL = '/';
export const FLEXI_12_PAGE_NAME = 'FLEXI12_DASHBOARD';

export const dashboardSagaWorkers = createWorkersForPage({
    page: FLEXI_12_PAGE_NAME,
    isInPageLocation: (location) => location.pathname === FLEXI_12_URL,
    createPageFlowWorkers: () => [fork(dashboardPageWorker)]
});

function* dashboardPageWorker() {
    yield takeLatest(ACTIVATE_FLEXI12_DASHBOARD, function* () {
        const [applicationResponse, accountsResponse] =
            yield putAndWaitHandleAllAPIError([
                { type: API_GET_APPLICATION },
                { type: API_GET_ACCOUNTS },
                { type: API_GET_CUSTOMER_STATE }
            ]);

        if (applicationResponse.response.data) {
            const defaultDashboardLocation = getDefaultDashboardLocation(
                applicationResponse.response,
                accountsResponse.response
            );

            if (defaultDashboardLocation !== null) {
                const disableRedirect = yield select(
                    (state) => state?.multiLoanDashboard?.disableRedirect
                );

                if (
                    defaultDashboardLocation.pathname === '/' ||
                    disableRedirect
                ) {
                    // Delegate to the multi-loan dashboard.
                    return yield* activateMultiLoanDashboard();
                }

                return yield put({
                    type: REQUEST_CHANGE_ROUTER,
                    location: defaultDashboardLocation
                });
            }

            const isIwocaPayCustomer = yield select(isIwocaPayCustomerSelector);
            const hasValidNonIwocapayAccounts = yield select((state) =>
                hasOtherValidAccounts(state, IWOCAPAY_PRODUCT_TYPE)
            );
            const hasValidNonIwocapayApplication = yield select((state) =>
                hasOtherValidApplications(state, IWOCAPAY_PRODUCT_TYPE)
            );
            if (
                isIwocaPayCustomer &&
                !hasValidNonIwocapayAccounts &&
                !hasValidNonIwocapayApplication
            ) {
                return yield put({
                    type: REQUEST_CHANGE_ROUTER,
                    location: { pathname: '/iwocapay/' }
                });
            }

            return yield* activateMultiLoanDashboard();
        } else {
            return yield put({
                type: REQUEST_CHANGE_ROUTER,
                location: { pathname: MY_OFFERS_URL }
            });
        }
    });
}
